import React from "react";
import get from "lodash/get";
import { AlsoInPackage } from "./AlsoInPackage";
import { WithLazy, StoryElement } from "@quintype/components";
import "./also-in-this-package.m.css";

export default function AlsoInThisPackage({ story, card }) {
  const cardStoryElements = get(card, ["story-elements"], []);
  const linkedStories = get(story, ["linked-stories"], []);

  const linkedStoryCollection = cardStoryElements
    .filter((ele) => ele.subtype === "also-read")
    .map((ele) => {
      const linkedStoryId = get(ele, ["metadata", "linked-story-id"], "");
      return linkedStories[linkedStoryId];
    });

  const showDefault = cardStoryElements.length && linkedStoryCollection.length === 0;

  return !showDefault ? (
    <div className="story-element story-element-also-in-the-package" styleName="also-in-this-package-wrapper">
      <p styleName="header">Also In This Package</p>
      <AlsoInPackage storyCollection={linkedStoryCollection} />
    </div>
  ) : (
    card["story-elements"].map((element) => {
      if (element.type === "image" || element.type === "jsembed" || element.type === "youtube-video") {
        return (
          <WithLazy margin="50px">
            {() => <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />}
          </WithLazy>
        );
      }
      return <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />;
    })
  );
}
